import DOMPurify from "dompurify";
import { useDispatch } from "react-redux";
import { useState, useEffect } from "react";
import { getTermsCondition } from "./action";
import "../../assets/scss/custom-styles.scss";

export default function PrivacyPolicy() {
  const [contentData, setContentData] = useState({
    content: "",
  });

  const dispatch: Function = useDispatch();

  useEffect(() => {
    dispatch(
      getTermsCondition({}, (result: any) => {
        result &&
          setContentData((prev) => ({
            ...prev,
            content: result.content,
          }));
      })
    );
  }, []);

  return contentData.content ? (
    <div
      className="cmsBody"
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(contentData.content),
      }}
    ></div>
  ) : null;
}
